'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isSupport = require('./ls');
var Logger = require('./logger');
var LS_KEY = 'owl_cache';
var LS_KEY_V2 = 'owl_cache_v2';

module.exports = {
    isSupport: isSupport(),
    get: function get() {
        if (!this.isSupport) return;
        var data = {};
        try {
            var rawV2 = localStorage.getItem(LS_KEY_V2); // new storage format - Object
            if (rawV2) {
                var tempV2 = JSON.parse(rawV2);
                if ((typeof tempV2 === 'undefined' ? 'undefined' : _typeof(tempV2)) === 'object' && Object.keys(tempV2).length) {
                    data = tempV2;
                }
            }
        } catch (e) {
            this.clear(LS_KEY_V2);
            Logger.ignore(e);
        }
        try {
            var raw = localStorage.getItem(LS_KEY); // history storage format - Array
            if (raw) {
                var temp = JSON.parse(raw);
                if (temp instanceof Array) {
                    data['no-version'] = temp.concat(data['no-version'] || []);
                }
            }
        } catch (e) {
            this.clear(LS_KEY);
            Logger.ignore(e);
        }
        return data;
    },
    add: function add(cache, version) {
        if (!this.isSupport) return;
        try {
            if (cache instanceof Array) {
                version = version || 'no-version';
                var preCache = this.get();
                if (preCache[version] instanceof Array) {
                    preCache[version] = cache.concat(preCache[version]);
                } else {
                    preCache[version] = cache;
                }
                localStorage.setItem(LS_KEY_V2, JSON.stringify(preCache));
            }
        } catch (e) {
            Logger.ignore(e);
        }
    },
    clear: function clear(key) {
        if (!this.isSupport) return;
        try {
            key = key || LS_KEY;
            localStorage.removeItem(key);
        } catch (e) {
            Logger.ignore(e);
        }
    },
    clearAll: function clearAll() {
        if (!this.isSupport) return;
        try {
            localStorage.removeItem(LS_KEY);
            localStorage.removeItem(LS_KEY_V2);
        } catch (e) {}
    },
    clearItem: function clearItem(version) {
        if (!this.isSupport) return;
        try {
            var preCache = this.get();
            if ((typeof preCache === 'undefined' ? 'undefined' : _typeof(preCache)) === 'object' && preCache.hasOwnProperty(version)) {
                delete preCache[version];
                if (Object.keys(preCache).length) {
                    localStorage.setItem(LS_KEY_V2, JSON.stringify(preCache));
                } else {
                    localStorage.removeItem(LS_KEY_V2);
                }
                if (version === 'no-version') {
                    localStorage.removeItem(LS_KEY);
                }
            }
        } catch (e) {
            Logger.ignore(e);
        }
    }
};